import { getIDVerificationEndpoint, methods } from '../../utils/apiHelper'
import { apiCall } from '../../utils/restclient'
import { LOAD_ACTION, ERROR_ACTION, GET_ID_VERIFICATION_SUCCESS } from './IDVerificationPopUpConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getIDVerification = (patientId, tabId) => {
  const endpoint = getIDVerificationEndpoint(patientId)
  const action = {
    type: LOAD_ACTION,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, methods.GET, null, null, {
      success: GET_ID_VERIFICATION_SUCCESS,
      error: ERROR_ACTION,
      extraData: { tabId, patientId },
    })
  } catch (e) {
    console.error(e)
  }
  return action
}
